import { getDateString, getDate1String } from "common/date-utils";
const getDateForName = (startDate, endDate, asOfDate) => {
    const toDate = endDate ?? asOfDate;
    const nameDate = ` from ${getDateString(startDate)} to ${getDateString(toDate)}`;
    return nameDate;
};
export const getActualName = (params) => {
    const { asOfDate, currentGranularity, endDate, showDateRange, selectedValues, startDate, widgetName, widgetProps } = params;
    let actualName = widgetName;
    // Replace date placeholders regardless of selected values (tests rely on this for widget6)
    if (actualName) {
        const date1 = getDate1String(currentGranularity, asOfDate);
        const date2 = getDateString(asOfDate);
        actualName = actualName.replace("[startDate]", date1);
        actualName = actualName.replace("[endDate]", date2);
    }
    // Replace select value placeholders if any selectedValues exist
    if (actualName && selectedValues) {
        Object.entries(selectedValues).forEach(([num, value]) => {
            const selectConfig = widgetProps?.dataSelectProps?.[Number(num)]?.selectValues?.[value];
            if (selectConfig?.displayName && actualName) {
                actualName = actualName.replace(`$${num}`, selectConfig.displayName);
            }
        });
    }
    if (actualName && startDate && showDateRange) {
        actualName += getDateForName(startDate, endDate, asOfDate);
    }
    return actualName;
};
